import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GraphService } from 'src/app/services/api/graph.service';
import { FilesViewMode } from '../model/programming-file';

interface ProgrammingFilesFiltersInput {
  year?: string | null;
  status?: string | null;
  search?: string | null;
  nameClient?: string | null;
  startDateFileFrom?: string | null;
  startDateFileTo?: string | null;
}

interface ProgrammingFilesSortInput {
  field: 'updatedAt' | 'startDateFile';
  direction: 'asc' | 'desc';
}

interface ProgrammingFilesInput {
  view: FilesViewMode;
  limit: number;
  cursor?: string | null;
  filters?: ProgrammingFilesFiltersInput;
  sort?: ProgrammingFilesSortInput;
}

export interface SalesClientFilterOptionsInput {
  search?: string | null;
  limit?: number;
}

export interface SalesClientFilterOption {
  nameClient: string;
}

@Injectable({ providedIn: 'root' })
export class FileProgrammingGraphqlApi {
  constructor(private readonly graphService: GraphService) {}

  getProgrammingFilesPage(input: ProgrammingFilesInput): Observable<any> {
    return this.graphService.queryGraphQLCore<any>({
      query: `query GetProgrammingFilesPage($input: GetProgrammingFilesInput!) {
        getProgrammingFilesPage(input: $input) {
          nextCursor
          items {
            id
            programmingViewType
            fileNumber
            fileExtend
            nombreItinerario
            nameClient
            usuario
            mainGuideName
            paxQuantity
            tcQuantity
            pendingPreOpIncidents
            pendingCsReviews
            displayState
            rowState
            paxAssigned
            flightsAssigned
            hasPartialFlights
            createdAt
            updatedAt
            startDateFile
          }
        }
      }`,
      variables: { input }
    });
  }

  getSalesClientFilterOptions(
    input: SalesClientFilterOptionsInput
  ): Observable<any> {
    return this.graphService.queryGraphQLCore<any>({
      query: `query GetSalesClientFilterOptions($input: GetSalesClientFilterOptionsInput) {
        getSalesClientFilterOptions(input: $input) {
          nameClient
          id
        }
      }`,
      variables: { input }
    });
  }

  getSalesPassengersByItinerary(idItinerary: string): Observable<any> {
    return this.graphService.queryGraphQLCore<any>({
      query: `query GetSalesPassengersByItinerary($idItinerary: String!) {
        getSalesPassengersByItinerary(idItinerary: $idItinerary) {
          Pax
          grupo
          pasajero {
            id
            firstName
            lastName
            height
            age
            weight
            size
            dateOfBirth
            dateOfPass
            doe
            residesInPeru
            documentType
            documentNumber
            passportNumber
            email
            phone
            gender
            alergias
            restriccionesAlimentarias
            condicionesMedicas
            country
            isTC
            updatedAt
          }
        }
      }`,
      variables: { idItinerary }
    });
  }
}
